// Readable text color (dark/light) for a given background hex — same idea as
// Recollect's tag contrast. Returns a CSS color string.
export function contrastText(hex) {
  if (typeof hex !== 'string') return '#1e2a3b';
  let h = hex.replace('#', '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (h.length !== 6) return '#1e2a3b';
  const rgb = [h.slice(0, 2), h.slice(2, 4), h.slice(4, 6)].map((x) => parseInt(x, 16));
  // WCAG relative luminance → pick black or white for the higher contrast ratio,
  // rather than a fixed YIQ threshold (which under-delivers near the boundary).
  const lin = (c) => { const s = c / 255; return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4; };
  const L = 0.2126 * lin(rgb[0]) + 0.7152 * lin(rgb[1]) + 0.0722 * lin(rgb[2]);
  // Contrast against the ACTUAL candidate colors (the app's near-black #1e2a3b,
  // L≈0.0226, and white), picking whichever wins — not pure #000, which would
  // mispredict the winner in a narrow mid-tone band.
  const ratio = (a, b) => (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
  return ratio(L, 0.0226) >= ratio(L, 1) ? '#1e2a3b' : '#ffffff';
}
